import React, { useState } from 'react';
import { TextField, Button, Typography, Paper, Box, Grid, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { requestOtp } from '../api';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Add loading state


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading
    setMessage(''); // Clear previous messages/errors
    setError('');

    try {
      await requestOtp(email); // Call your requestOtp API
      setMessage('An OTP has been sent to your email address.');
      setError('');
      // Redirect to OTP verification page WITHOUT passing email in URL
      navigate('/otp-verification');
    } catch (err) {
      setError(err.message || 'Failed to send OTP.');
      setMessage('');
    } finally {
      setLoading(false); // End loading
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid item xs={12} sm={8} md={5} lg={4}>
        <Paper elevation={6} sx={{ p: 3 }}>
          <Typography variant="h5" align="center" gutterBottom>
            Forgot Password
          </Typography>
          {message && <Typography color="success" align="center" sx={{ mb: 2 }}>{message}</Typography>}
          {error && <Typography color="error" align="center" sx={{ mb: 2 }}>{error}</Typography>}
          <form onSubmit={handleSubmit}>
            <Box mb={3}>
              <TextField
                fullWidth
                label="Email Address"
                variant="outlined"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading} // Disable input while loading
              />
            </Box>
            <Button variant="contained" color="primary" type="submit" fullWidth
            disabled={loading} // Disable button while loading
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null} // Show spinner
            >
              {loading ? 'Sending...' : 'Send Reset Link'} {/* Change text while loading */}
            </Button>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default ForgotPasswordPage;